import { render, staticRenderFns } from "./SalesPointInformation.vue?vue&type=template&id=626bd7fd&scoped=true&"
import script from "./SalesPointInformation.vue?vue&type=script&lang=ts&"
export * from "./SalesPointInformation.vue?vue&type=script&lang=ts&"
import style0 from "./SalesPointInformation.vue?vue&type=style&index=0&id=626bd7fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626bd7fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDivider,VIcon})
